module.exports = __webpack_public_path__ + "static/media/DSC_0552.830bbf1f.jpg";